<template lang="pug">
v-container.justify-center.mt-6.mt-md-10.mb-5.page-item
  .py-10.d-flex.justify-center(v-if="!item.title")
    v-progress-circular(size="50", color="primary", indeterminate)
  template(v-else)
    custom-title(simple, style="border-color: var(--v-primary-base)") {{ item.title }}
    .d-flex.align-center.mb-4
      v-breadcrumbs.mt-4.mt-md-6.pa-0.font-weight-bold(:items="breadcrumbs")
        template(#divider)
          v-icon(x-small) fas fa-chevron-right
    div
      .mt-6.ck-content(v-html="item.text")

    v-sheet.mt-6.d-flex.justify-center(v-if="item.video", color="black")
      v-sheet(
        color="transparent",
        width="100%"
        max-width="960px",
        style="aspect-ratio: 16 / 9"
      )
        iframe.d-block(
          width="100%",
          height="100%",
          :src="`https://www.youtube.com/embed/${getYoutubeCode(item.video)}`",
          title="YouTube video player",
          frameborder="0",
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
          allowfullscreen
        )

    template(v-if="gallery.length")
      Tinybox(v-model="galleryIndex", :images="gallery")
      .mt-6.gallery-list
        template(v-for="(img, i) in gallery")
          a(:key="i", @click="galleryIndex = i")
            img.d-block.img-gallery(:src="img", width="100%")
</template>

<script>
import CustomTitle from "../../others/CustomTitle.vue";
import { getYoutubeCode } from "../../utils";
import Tinybox from "vue-tinybox";

export default {
  data: () => ({
    item: {},
    galleryIndex: null,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    breadcrumbs() {
      const { category } = this.item;

      const r = [
        {
          text: "Início",
          exact: true,
          to: "/",
        },
        {
          text: "Eventos",
          exact: true,
          to: "/eventos",
        },
      ];

      if (!category || !category.id) return r;
      r.push({
        text: category.title,
        exact: true,
        to: `/eventos?c=${category.id}`,
      });

      return r;
    },
    gallery() {
      const item = this.item;

      if (item && item.img && item.img.list && item.img.list.length)
        return item.img.list.map(({ path }) => {
          return this.files + path;
        });

      return [];
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getYoutubeCode,
  },
  watch: {
    itemId(v) {
      this.$rest("galleries").get({ id: v });
    },
  },
  created() {
    this.item = {};

    this.$rest("galleries")
      .get({ id: this.itemId })
      .then((data) => (this.item = data))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  components: {
    CustomTitle,
    Tinybox,
  },
};
</script>

<style>
.page-item .v-breadcrumbs__item {
  color: var(--v-secondary-darken4);
}

.gallery-list {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(6, 1fr);
}

@media screen and (max-width: 1904px) {
  .gallery-list {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media screen and (max-width: 1264px) {
  .gallery-list {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (max-width: 960px) {
  .gallery-list {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 600px) {
  .gallery-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

.img-gallery {
  aspect-ratio: 4 / 3;
  object-fit: cover;
}
</style>
